/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { Card, CardBody, Row, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, } from 'reactstrap'
import { getDocs } from '../../../utils/fc'
import PdfView from '../../Modal/PdfView'
import AddFiles from '../Files/AddFiles'
import oikosApi from '../../../services/oikos'
import { notifyError, notifySuccess } from '../../../utils/notify'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'


class DocTab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: false,
      dataIsLoading: false,
      deleteIsLoading: false,
      isOpen: false,
      pdfPath: '',
      isFilesModalOpen: false,
      deleteModalOpen: false,
      isUploading: false,
      arquivoData: {},
    }
  }

  filesRef = React.createRef();

  componentDidMount() {
    this.preloading()
  }

  preloading = async() => {
    console.log(this.props)
    this.setState({dataIsLoading: true })
    //const data = await getDocs(this.props.refTable, this.props.refId)
    //this.setState({ data, dataIsLoading: false, dataProj })
    const dataProj = await getDocs(this.props.refTable, this.props.refId)
    const dataContrato = await getDocs('contrato', this.props.contrato_id)
    console.log("data do DocTab ", dataProj)
    const additiveContractsDocsArray = [];
    if (this.props.additiveContractsArray) {
      for (const additiveContract of this.props.additiveContractsArray) {
        console.log(additiveContract)
        const additiveContractDocs = await getDocs('contrato', additiveContract.contrato_id)
        additiveContractsDocsArray.push(...additiveContractDocs)
      }
    }
    this.setState({ dataIsLoading: false, dataProj: [...dataProj, ...dataContrato, ...additiveContractsDocsArray] })
  }

  handleSubmitFiles = async () => {
    const files = this.filesRef?.current?.state?.files

    this.setState({isUploading: true})

    if (files.length > 0) {
      await Promise.all(files.map(async file => {
        // Cria um registro na tabela de documentos para cada arquivo
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: file.props?.documentType?.tpDocumento_id,
            documento_desc: file.props?.description,
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre o documento (anexo) e o contrato
        if (documentCreated.data[0].documento_id && this.props.proj_id) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'proj',
              documentoVinc_tabId: this.props.proj_id,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        // Faz upload do arquivo e registra na tabela 'arquivo'
        const formData = new FormData()
        formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', file.data.path)
        const fileUploadRes = await oikosApi.post('/', formData)
        console.tron.log('fileUploadRes', fileUploadRes)
      }))
    }

    console.log('arquivos enviados com sucesso. Carregando novamente...')

    this.setState({isFilesModalOpen: false})
    this.setState({isUploading: false})

    this.preloading()
    /*
    */
  }

  deleteDocuments = async (docId) => {
    this.setState({ deleteIsLoading: true });
    try {
      const deleteDoc = {
        action: 'delete',
        table: 'documento',
        data: {
          documento_id: Number(docId),
        },
      }
      console.log('deleteDoc ', deleteDoc)
      const productDeleted = await oikosApi.post('/', deleteDoc)
      notifySuccess('Documento removido com sucesso.')
      this.preloading()
    } catch (e) {
      notifyError('Erro ao remover o documento');
      console.log('Não foi possível remover o documento.', e)
    }
    this.setState({ deleteIsLoading: false, deleteModalOpen: false })
  }

  render() {
    const { dataIsLoading, data, isOpen, pdfPath, pdfHeader, dataProj } = this.state
    const { user } = this.props.auth

    if (dataIsLoading) {
      return (
        <Card>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (dataProj) {
      return (
        <>
          <Card>
            <CardBody>
              <Row>
                <Col>
                 <CardHeader>
                  <div className='d-flex justify-content-between align-items-center'>
                    Anexos
                    <Button
                      size="sm"
                      color="link"
                      className="mb-1 ml-1 px-0"
                      onClick={() => this.setState({ isFilesModalOpen: true })}
                    >
                      Adicionar novo
                    </Button>
                  </div>
                 </CardHeader>
                 {dataProj.map(i => (
                  <>
                    <Card>
                      <CardBody>
                        <Row className="align-items-center justify-content-between">
                          <Col>
                            <Row>
                              <Col xs="auto">
                                <p style={{ fontWeight: 'bold' }}>
                                  <a
                                  href={`https://oikos.ecoss.is/oikos/${i.arquivo_caminho}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  >
                                  {i.documento_desc}
                                  </a>
                                </p>
                              </Col>
                            </Row>

                          </Col>
                          {user.perm_id === 1 &&
                            <Button
                              title="Excluir"
                              className="mr-2"
                              color="light"
                              size="sm"
                              onClick={() => this.setState({ deleteModalOpen: true, arquivoData: i })}
                            >
                              <i className="ri-delete-bin-6-line" />
                            </Button>
                          }
                        </Row>
                      </CardBody>
                    </Card>
                  </>
                  ))}
                 {/*}
                  {data.map(i => (
                    <Card>
                      {console.log(i)}
                      <CardBody>
                        <Row className="align-items-center">
                          <Col>
                            <Row className='justify-content-between'>
                              <Col xs="auto">
                                <p style={{ fontWeight: 'bold' }}>
                                <a
                                href={`https://oikos.ecoss.is/oikos/${i.arquivo_caminho}`}
                                target="_blank"
                                rel="noreferrer"
                                >
                                {i.documento_desc}
                                </a>

                                </p>
                              </Col>
                              <Button
                                title="Excluir"
                                className="mr-2"
                                color="light"
                                size="sm"
                                onClick={() => console.log('delete')}
                              >
                                <i className="ri-delete-bin-6-line" />
                              </Button>
                            </Row>

                          </Col>
                          </Row>
                      </CardBody>
                    </Card>
                  ))}
                      <DataTable
                      className="table-clickable"
                      sortable={['proj_dtCria', 'desc']}
                      data={{
                        columns: [
                          {
                            label: 'Descrição',
                            field: 'arquivo_caminho',
                          },
                          {
                            label: 'Download',
                            field: 'download',
                          },
                           {
                            label: 'View',
                            field: 'view',
                          },
                        ],
                        rows: data.map(i => ({
                          documento_desc: i.documento_desc,
                          arquivo_caminho: <a href={`https://oikos.ecoss.is/oikos/${i.arquivo_caminho}`} >
                                             {i.documento_desc}</a>,
                          download:  <Button
                                       onClick={() => forceDownload(`https://oikos.ecoss.is/oikos/${i.arquivo_caminho}`, i.documento_desc, { type: 'application/pdf' })}
                                       title="Download"
                                       className="ml-2"
                                       color="light"
                                       size="sm"
                                       style={{ width: 32, height: 32 }}
                                       >
                                       <i className=" ri-file-download-fill"/>
                                     </Button>,
                          view:       <Button
                                        onClick={() => this.setState(
                                          {
                                            isOpen: true,
                                            pdfPath: `https://oikos.ecoss.is/oikos/${i.arquivo_caminho}`,
                                            pdfHeader: i.documento_desc,
                                          }
                                        )}
                                        title="Download"
                                        className="ml-2"
                                        color="light"
                                        size="sm"
                                        style={{ width: 32, height: 32 }}
                                        >
                                        <i className=" ri-file-download-fill"/>
                                      </Button>,
                        })),
                      }}
                    />*/}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <PdfView
            isOpen={isOpen}
            Path={pdfPath}
            Header={pdfHeader}
            toggle={() => {
              this.setState({
                isOpen: false,
              })
            }} />
          <Modal
            size='lg'
            centered={false}
            isOpen={ this.state.isFilesModalOpen}
            toggle={() => this.setState({ addEquiProjData: {}, isFilesModalOpen: false })}
          >
            <ModalHeader
              toggle={() => this.setState({
              isFilesModalOpen: false,
            })}
            >
              Adição de Documentos
            </ModalHeader>
            <ModalBody>
              <AddFiles
                drop={false}
                multiple={true}
                ref={this.filesRef}
                accept={['.pdf']}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.setState({ isFilesModalOpen: false })}
                color="light"
                className="waves-effect"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => {
                  this.handleSubmitFiles()
                }
                }

              >
                {!this.state.isUploading ? 'Adicionar' : <Spinner size={'sm'} />}
              </Button>
            </ModalFooter>
          </Modal>
          <Modal
            size='sm'
            centered
            isOpen={ this.state.deleteModalOpen}
            toggle={() => this.setState({ deleteModalOpen: true })}
          >
            <ModalHeader>
              Confirmação de deleção
            </ModalHeader>
            <ModalBody>
              Confirma a deleção do documento <strong>{this.state.arquivoData.documento_desc}?</strong>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.setState({ deleteModalOpen: false })}
                color="light"
                className="waves-effect"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => {
                    this.deleteDocuments(this.state.arquivoData.documento_id);
                  }
                }

              >
                {!this.state.deleteIsLoading ? 'Deletar' : <Spinner size={'sm'} />}
              </Button>
            </ModalFooter>
          </Modal>
        </>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ auth: state.auth })
export default connect(mapStateToProps)(DocTab)
